import BxTable from "../bx-components/BxTable";
import BxTableColumn from "../bx-components/BxTableColumn";
import BxBtn from "../bx-components/BxBtn";
import BxReceptionBoxStatus from "../bx-components/BxReceptionBoxStatus";
import common from "@/utils/common";

export default {
  name: "inbound-box-detail",
  mixins: [common],
  components: { BxReceptionBoxStatus, BxBtn, BxTableColumn, BxTable },
  props: {
    id: {
      type: [Number, String]
    },
    orderId: {
      type: [Number, String]
    }
  },
  data() {
    return {
      key: "inbound_box_detail",
      shouldLoading: true,
      columns: [],
      filters: {},
      data: [],
      dataList: [],
      receptionBoxData: null,
      receptionTime: "",
      waitingTime: "",
      itemCount: "",
      name: "",
      status: 0,
      contents: [],
      reloadInterval: null,
      API_BASE: process.env.VUE_APP_API_BASE,
      itemsPerPage: 8,
      page: 1
    };
  },
  computed: {
    location() {
      return localStorage.getItem("location");
    }
  },
  methods: {
    loadMore() {
      if (
        !this.shouldLoading &&
        this.dataList.length &&
        this.dataList.length < this.itemCount &&
        this.isMobile
      ) {
        this.page++;
        this.getData();
      }
    },
    updatePage(p) {
      this.page = p;
      this.getData(this.locationId);
    },
    async getData() {
      try {
        if (this.isMobile) {
          this.shouldLoading = true;
        }
        this.receptionBoxData = await this.$api.reception_boxes.get(this.id);
        this.receptionTime = this.receptionBoxData.reading_time;
        this.status = this.receptionBoxData.status;
        this.waitingTime = this.receptionBoxData.waiting_time;
        this.name = this.receptionBoxData.order_name;
        this.report = await this.$api.reception_boxes.report(this.id, {
          item_type__gtin__contains: this.filters.gtin
        });
        this.itemCount = this.report.length;
        this.data = this.report.map((item, key) => {
          return {
            gtin: item.gtin,
            itemType: item.item_type,
            theorical_item_count: item.theorical_item_count,
            real_item_count: item.real_item_count,
            cloth_type: item.cloth_type,
            id: item.id,
            size: item.size,
            color: item.colour,
            description: item.description,
            model: item.model,
            section: item.section,
            ratingPercent:
              (item.real_item_count / item.theorical_item_count) * 100
          };
        });
        if (this.isMobile) {
          this.dataList = this.dataList.concat(this.data);
        }
        this.columns = [
          {
            field: "gtin",
            label: this.$t("lang.inbound.box_detail.table_field_1"),
            filter: {
              placeholder: this.$t(
                "lang.inbound.dashboard.table_field_placeholder_4"
              ),
              value: this.filters.gtin
            }
          },
          {
            field: "theorical_item_count",
            label: this.$t("lang.inbound.box_detail.table_field_2")
          },
          {
            field: "real_item_count",
            label: this.$t("lang.inbound.box_detail.table_field_3")
          },
          {
            field: "description",
            label: this.$t("lang.inbound.box_detail.description")
          },
          {
            field: "section",
            label: this.$t("lang.inbound.box_detail.table_field_4")
          },
          {
            field: "itemtype",
            label: this.$t("lang.inbound.box_detail.table_field_5")
          },
          {
            field: "model",
            label: this.$t("lang.inbound.box_detail.table_field_6")
          },
          {
            field: "color",
            label: this.$t("lang.inbound.box_detail.table_field_7")
          },
          {
            field: "size",
            label: this.$t("lang.inbound.box_detail.table_field_8")
          },
          {
            field: "ratingPercent",
            label: this.$t("lang.inbound.box_detail.table_field_9"),
            width: 200
          }
        ];
      } catch (error) {
        console.error(error);
      } finally {
        this.shouldLoading = false;
      }
    },
    onSearch(field, value) {
      this.$session.set(this.key + field, value);
      switch (field) {
        case "gtin":
          this.filters.gtin = value;
          this.getData();
          break;
      }
    }
  },
  mounted() {
    if (!this.isMobile) {
      this.reloadInterval = setInterval(
        this.getData,
        process.env.VUE_APP_RELOAD_TIME
      );
    }
    this.getData();
    this.filters.gtin = this.$session.get(this.key + "gtin");
  },
  beforeDestroy() {
    clearInterval(this.reloadInterval);
  }
};
